import { render, staticRenderFns } from "./HotelCollapse.vue?vue&type=template&id=205e1358&scoped=true&"
import script from "./HotelCollapse.vue?vue&type=script&lang=js&"
export * from "./HotelCollapse.vue?vue&type=script&lang=js&"
import style0 from "./HotelCollapse.vue?vue&type=style&index=0&id=205e1358&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e1358",
  null
  
)

export default component.exports